module.exports = __webpack_public_path__ + "static/405-6328e443d88d4c012d02a5e31ddac044.png";